<ng-container *transloco="let t">
  <!-- Use flex with column direction and set a fixed height -->
  <div class="flex flex-col h-full max-h-[80vh]">
    <!-- Content section - scrollable -->
    <div class="flex-1 overflow-y-auto">
      @if (translocoService.getActiveLang() === "en") {
        <!-- ENGLISH CONTENT -->
        <div class="mb-5">
          @if (config.data?.organization?.tosAcceptedByUser) {
            <p class="dark:text-surface-400">
              {{ config.data?.organization?.tosAcceptedByUser?.fullName }} accepted the Terms of Service on
              {{ config.data?.organization?.tosAcceptedAt | ranDate: "dateLong" }}.
            </p>
          } @else {
            <p class="dark:text-surface-400">
              Organization administrator must accept the Terms of Service before proceeding to use the service.
            </p>
          }
        </div>
        <p-fluid class="pr-4">
          Organization: <strong>{{ config.data?.organization?.name! }}</strong>
          <br />
          Effective date: <strong>{{ effectiveDate | ranDate: "dateLong" }}</strong>
          <br />
          Last updated: <strong>{{ lastUpdatedDate | ranDate: "dateLong" }}</strong> <br /><br />
          <strong>1. General</strong>
          <br /><br />
          RAN Group Oy ("RAN Group", "we", "our", "us") provides RAN Connect (the "Service") for its customers and other
          organizations (the "Customer", "you"). The Service is a secure online platform enabling communication,
          document sharing, and process management between RAN Group employees and the customers.
          <br /><br />
          By selecting "I accept" or by accessing or using the Service, you agree to be bound by these Terms. The
          agreement concerning the use of the Service consists of these Terms of Service, a customer-specific contract
          of services, Taloushallintoliitto's general conditions (TAL2023), and the Data Processing Agreement available
          at
          <a [href]="brandService.brand().gdprUrls.en" target="_blank">{{ brandService.brand().gdprUrls.en }}</a
          >. In the event of any conflict, the order of precedence shall be: (1) customer-specific contract, (2) DPA,
          (3) TAL2023, (4) these Terms. <br /><br />
          <strong>2. Pricing and Changes to Pricing</strong>
          <br /><br />
          The Service is provided for Customers free of charge. However, some optional features may be subject to
          separate charges. These charges will always be communicated to the Customer in advance, and the Customer can
          choose to enable such paid features within the Service. We may also introduce new paid features or adjust fees
          with 30 days' prior notice, and the Customer may disable such features before the change takes effect.
          <br /><br />
          <strong>3. Scope of Service</strong>
          <br /><br />
          RAN Connect provides secure file transfer and process management between RAN Group and Customers. The Service
          is intended exclusively for business use in connection with RAN Group's accounting, payroll, and advisory
          services. New features may be added to the Service without explicit prior notice.
          <br /><br />
          <strong>4. User Responsibilities</strong>
          <br /><br />
          You agree to keep login credentials confidential and secure, ensure that any files or messages you upload do
          not violate applicable laws or infringe third-party rights, and use the Service only for lawful business
          purposes and in compliance with these Terms.
          <br /><br />
          Prohibited actions include uploading malware, unlawful, or offensive content; attempting to gain unauthorised
          access to the Service or its infrastructure; and using the Service to compete with RAN Group.
          <br /><br />
          <strong>5. Data Protection & Confidentiality</strong>
          <br /><br />
          RAN Group processes personal data in accordance with applicable Finnish and EU (GDPR) laws. All information
          and files exchanged via RAN Connect are treated as confidential, and we implement industry-standard security
          measures to protect them. However, you acknowledge that no online system can be 100% secure.
          <br /><br />
          For personal data, the Customer acts as the controller and RAN Group acts as the processor. The parties' data
          processing is governed by the DPA referenced above.
          <br /><br />
          <strong>6. Intellectual Property</strong>
          <br /><br />
          All rights, title, and interest in RAN Connect, including software, trademarks, and content, remain with RAN
          Group. Users are granted a limited, non-exclusive, non-transferable licence to use the Service during the term
          of engagement with RAN Group.
          <br /><br />
          <strong>7. Availability & Support</strong>
          <br /><br />
          We strive to provide continuous availability but do not guarantee uninterrupted or error-free availability of
          the Service. Planned maintenance or updates may result in temporary unavailability, and support is provided
          through {{ brandService.brand().supportEmail }}. <br /><br />
          <strong>8. Account Management and Customer Data</strong>
          <br /><br />
          The Customer is responsible for configuring access rights, keeping credentials secure, and all activities
          under its accounts. The Customer must promptly disable access for departing users. Access to the Service may
          be granted only to authorised employees, representatives, or partners of Customers engaged with RAN Group.
          <br /><br />
          As between the parties, the Customer owns all data and content submitted to the Service ('Customer Data'). The
          Customer grants RAN Group a non-exclusive licence to host, process, and transmit Customer Data solely to
          provide and support the Service. RAN Group may also use Customer Data in an anonymised and aggregated form to
          develop, improve, or enhance its services or for other lawful purposes.
          <br /><br />
          <strong>9. Termination</strong>
          <br /><br />
          Either party may terminate access upon written notice, subject to contractual obligations. RAN Group may
          suspend or terminate access immediately if the Service is misused or if these Terms are violated. If the
          Customer terminates the contract, they will lose access to the Service.
          <br /><br />
          <strong>10. Limitation of Liability</strong>
          <br /><br />
          RAN Group shall not be liable for indirect, incidental, or consequential damages arising from use of the
          Service.
          <br /><br />
          <strong>11. Changes to Terms</strong>
          <br /><br />
          We may update these Terms from time to time. Material changes will be communicated to Users. Continued use of
          the Service after updates constitutes acceptance of the new Terms.
          <br /><br />
          <strong>Contact</strong>
          <br />
          {{ brandService.brand().supportEmail }}
          <br />
          {{ brandService.brand().legalEmail }}
        </p-fluid>
      } @else if (translocoService.getActiveLang() === "fi") {
        <!-- FINNISH CONTENT -->
        <div class="mb-5">
          @if (config.data?.organization?.tosAcceptedByUser) {
            <p class="dark:text-surface-400">
              {{ config.data?.organization?.tosAcceptedByUser?.fullName }} on hyväksynyt palvelun käyttöehdot
              {{ config.data?.organization?.tosAcceptedAt | ranDate: "dateLong" }}.
            </p>
          } @else {
            <p class="dark:text-surface-400">
              Organisaation pääkäyttäjän tulee hyväksyä palvelun käyttöehdot ennen kuin palvelua voidaan käyttää.
            </p>
          }
        </div>
        <p-fluid class="pr-4">
          Organisaatio: <strong>{{ config.data?.organization?.name! }}</strong>
          <br />
          Voimaantulopäivä: <strong>{{ effectiveDate | ranDate: "dateLong" }}</strong>
          <br />
          Viimeksi päivitetty: <strong>{{ lastUpdatedDate | ranDate: "dateLong" }}</strong> <br /><br />
          <strong>1. Yleistä</strong>
          <br /><br />
          RAN Group Oy ("RAN Group", "me", "meidän") tarjoaa RAN Connectin ("Palvelu") asiakkailleen ja muille
          organisaatioille ("Asiakas", "sinä"). Palvelu on turvallinen verkkoalusta, joka on suunniteltu helpottamaan
          RAN Groupin työntekijöiden ja asiakkaiden välistä viestintää, asiakirjojen jakamista ja prosessihallintaa.
          <br /><br />
          Valitsemalla "Hyväksyn", käymällä palvelussa tai käyttämällä sitä, hyväksyt nämä ehdot. Palvelun käyttöä
          koskeva sopimus muodostuu näistä Käyttöehdoista, asiakaskohtaisesta palvelusopimuksesta, Taloushallintoliiton
          yleisistä sopimusehdoista (TAL2023) sekä osoitteesta
          <a [href]="brandService.brand().gdprUrls.fi" target="_blank">{{ brandService.brand().gdprUrls.fi }}</a
          >. Ristiriitatilanteissa etusijajärjestys on seuraava: (1) asiakaskohtainen sopimus, (2)
          tietojenkäsittelysopimus, (3) TAL2023, (4) nämä ehdot. <br /><br />
          <strong>2. Hinnoittelu ja hinnoittelun muutokset</strong>
          <br /><br />
          Palvelu tarjotaan Asiakkaille maksutta. Joistakin valinnaisista ominaisuuksista saatetaan kuitenkin periä
          erillinen maksu. Näistä maksuista ilmoitetaan Asiakkaalle aina etukäteen, ja Asiakas voi valita, haluaako hän
          ottaa kyseiset maksulliset ominaisuudet käyttöön Palvelussa. Saatamme myös lisätä uusia maksullisia
          ominaisuuksia tai muuttaa maksuja 30 päivän ennakkoilmoituksella, ja Asiakas voi poistaa tällaiset
          ominaisuudet käytöstä ennen muutoksen voimaantuloa.
          <br /><br />
          <strong>3. Palvelun laajuus</strong>
          <br /><br />
          RAN Connect tarjoaa turvallisen tiedostojen siirron ja prosessihallinnan RAN Groupin ja Asiakkaiden välillä.
          Palvelu on tarkoitettu yksinomaan yrityskäyttöön RAN Groupin kirjanpito-, palkanlaskenta- ja
          neuvontapalveluissa. Palveluun voidaan lisätä uusia ominaisuuksia ilman nimenomaista ennakkoilmoitusta.
          <br /><br />
          <strong>4. Käyttäjän velvollisuudet</strong>
          <br /><br />
          Sitoudut pitämään kirjautumistiedot luottamuksellisina ja turvattuina; varmistamaan, että lataamasi tiedostot
          tai viestit eivät riko sovellettavia lakeja tai loukkaa kolmansien osapuolten oikeuksia; ja käyttämään
          palvelua vain laillisiin liiketoimintatarkoituksiin ja näiden ehtojen mukaisesti.
          <br /><br />
          Kiellettyjä toimia ovat esimerkiksi haittaohjelmien, laittoman tai loukkaavan sisällön lataaminen, pyrkimys
          saada luvaton pääsy Palveluun tai sen infrastruktuuriin ja Palvelun käyttäminen RAN Groupin kanssa
          kilpailemiseen.
          <br /><br />
          <strong>5. Tietosuoja ja luottamuksellisuus</strong>
          <br /><br />
          RAN Group käsittelee henkilötietoja sovellettavien Suomen ja EU:n (GDPR) lakien mukaisesti. Kaikkia RAN
          Connectin kautta vaihdettuja tietoja ja tiedostoja käsitellään luottamuksellisina, ja käytämme alan
          standardien mukaisia turvatoimia niiden suojaamiseksi. Ymmärrät kuitenkin, että mikään verkkojärjestelmä ei
          voi olla 100-prosenttisen turvallinen.
          <br /><br />
          Henkilötietojen osalta Asiakas toimii rekisterinpitäjänä ja RAN Group henkilötietojen käsittelijänä.
          Osapuolten tietojenkäsittelyyn sovelletaan edellä mainittua tietojenkäsittelysopimusta.
          <br /><br />
          <strong>6. Immateriaalioikeudet</strong>
          <br /><br />
          Kaikki RAN Connectiin liittyvät oikeudet, omistusoikeudet ja edut, mukaan lukien ohjelmistot, tavaramerkit ja
          sisältö, pysyvät RAN Groupilla. Käyttäjille myönnetään rajoitettu, ei-yksinomainen, ei-siirrettävä
          käyttöoikeus palveluun RAN Groupin kanssa tehdyn sopimuksen voimassaoloaikana.
          <br /><br />
          <strong>7. Saatavuus ja tuki</strong>
          <br /><br />
          Pyrimme tarjoamaan jatkuvan saatavuuden, mutta emme takaa palvelun keskeytymätöntä tai virheetöntä
          saatavuutta. Suunniteltu ylläpito tai päivitykset voivat johtaa tilapäiseen katkokseen Palvelussa, ja tukea on
          saatavilla osoitteessa {{ brandService.brand().supportEmail }}. <br /><br />
          <strong>8. Tilinhallinta ja asiakastiedot</strong>
          <br /><br />
          Asiakas on vastuussa käyttöoikeuksien määrittämisestä, tunnistetietojen suojaamisesta ja kaikista tileillään
          tapahtuvista toimista. Asiakkaan on viipymättä estettävä poistuvien käyttäjien pääsy Palveluun. Pääsy
          palveluun voidaan myöntää vain RAN Groupin kanssa toimivien asiakkaiden valtuutetuille työntekijöille,
          edustajille tai yhteistyökumppaneille.
          <br /><br />
          Osapuolten välillä Asiakas omistaa kaikki Palveluun toimitetut tiedot ja sisällön ("Asiakastiedot"). Asiakas
          myöntää RAN Groupille ei-yksinomaisen lisenssin asiakastietojen isännöintiin, käsittelyyn ja välittämiseen
          yksinomaan Palvelun tarjoamiseksi ja tukemiseksi. RAN Group voi myös käyttää asiakastietoja anonymisoidussa ja
          kootussa muodossa kehittääkseen, parantaakseen tai tehostaakseen palvelujaan tai muihin laillisiin
          tarkoituksiin.
          <br /><br />
          <strong>9. Sopimuksen irtisanominen</strong>
          <br /><br />
          Kumpikin osapuoli voi irtisanoa käyttöoikeuden kirjallisella ilmoituksella sopimusvelvoitteiden mukaisesti.
          RAN Group voi keskeyttää tai lopettaa käyttöoikeuden välittömästi, jos Palvelua käytetään väärin tai jos näitä
          ehtoja rikotaan. Jos Asiakas irtisanoo sopimuksen, hän menettää pääsyn Palveluun.
          <br /><br />
          <strong>10. Vastuunrajoitus</strong>
          <br /><br />
          RAN Group ei ole vastuussa palvelun käytöstä aiheutuvista epäsuorista, satunnaisista tai välillisistä
          vahingoista.
          <br /><br />
          <strong>11. Muutokset ehtoihin</strong>
          <br /><br />
          Saatamme päivittää näitä ehtoja aika ajoin. Käyttäjille ilmoitetaan olennaisista muutoksista. Palvelun käytön
          jatkaminen päivitysten jälkeen merkitsee uusien ehtojen hyväksymistä.
          <br /><br />
          <strong>Yhteystiedot</strong>
          <br />
          {{ brandService.brand().supportEmail }}
          <br />
          {{ brandService.brand().legalEmail }}
        </p-fluid>
      } @else if (translocoService.getActiveLang() === "sv") {
        <!-- SWEDISH CONTENT -->
        <div class="mb-5">
          @if (config.data?.organization?.tosAcceptedByUser) {
            <p class="dark:text-surface-400">
              {{ config.data?.organization?.tosAcceptedByUser?.fullName }} har godkänt användarvillkoren
              {{ config.data?.organization?.tosAcceptedAt | ranDate: "dateLong" }}.
            </p>
          } @else {
            <p class="dark:text-surface-400">
              Organisationens administratör måste godkänna användarvillkoren innan tjänsten kan användas.
            </p>
          }
        </div>
        <p-fluid class="pr-4">
          Organisation: <strong>{{ config.data?.organization?.name! }}</strong>
          <br />
          Datum för ikraftträdande: <strong>{{ effectiveDate | ranDate: "dateLong" }}</strong>
          <br />
          Senast uppdaterad : <strong>{{ lastUpdatedDate | ranDate: "dateLong" }}</strong> <br /><br />
          <strong>1. Allmänt</strong>
          <br /><br />
          RAN Group Oy (RAN Group, vi, vår, oss) tillhandahåller RAN Connect (Tjänsten) till sina kunder och andra
          organisationer (Kunden, du). Tjänsten är en säker onlineplattform som är utformad för att underlätta
          kommunikation, dokumentdelning och processhantering mellan RAN Groups anställda och kunder.
          <br /><br />
          Genom att välja "Jag godkänner" eller genom att använda tjänsten godkänner du att vara bunden av dessa
          villkor. Avtalet om användning av tjänsten består av dessa användarvillkor, ett kundspecifikt tjänsteavtal,
          Ekonomiförvaltningsförbundets allmänna avtalsvillkor (TAL2023) och databehandlingsavtalet som finns
          tillgängligt på
          <a [href]="brandService.brand().gdprUrls.sv" target="_blank">{{ brandService.brand().gdprUrls.sv }}</a
          >. Vid eventuella konflikter ska prioritetsordningen vara följande: (1) kundspecifikt avtal, (2)
          databehandlingsavtal, (3) TAL2023, (4) dessa villkor. <br /><br />
          <strong>2. Prissättning och ändringar av prissättning</strong>
          <br /><br />
          Tjänsten tillhandahålls Kunderna kostnadsfritt. Vissa tillvalsfunktioner kan dock vara föremål för separata
          avgifter. Dessa avgifter kommer alltid att meddelas Kunden i förväg och Kunden kan välja att aktivera sådana
          avgiftsbelagda funktioner i Tjänsten. Vi kan också införa nya avgiftsbelagda funktioner eller justera
          avgifterna med 30 dagars varsel, och Kunden kan inaktivera sådana funktioner innan ändringen träder i kraft.
          <br /><br />
          <strong>3. Tjänstens omfattning</strong>
          <br /><br />
          RAN Connect tillhandahåller säker filöverföring och processhantering mellan RAN Group och Kunder. Tjänsten är
          avsedd uteslutande för affärsmässigt bruk i samband med RAN Groups redovisnings-, löne- och
          rådgivningstjänster. Nya funktioner kan komma att läggas till i Tjänsten utan uttryckligt förhandsmeddelande.
          <br /><br />
          <strong>4. Användaransvar</strong>
          <br /><br />
          Du samtycker till att hålla inloggningsuppgifterna konfidentiella och säkra, se till att inga filer eller
          meddelanden som du laddar upp bryter mot gällande lagar eller kränker tredje parts rättigheter, samt att
          endast använda Tjänsten för lagliga affärsändamål och i enlighet med dessa villkor.
          <br /><br />
          Förbjudna åtgärder inkluderar att ladda upp skadlig programvara, olagligt eller stötande innehåll, försöka få
          obehörig åtkomst till Tjänsten eller dess infrastruktur samt använda tjänsten för att konkurrera med RAN
          Group.
          <br /><br />
          <strong>5. Dataskydd och sekretess</strong>
          <br /><br />
          RAN Group behandlar personuppgifter i enlighet med tillämpliga finska lagar och EU-lagar (GDPR). All
          information och alla filer som utbyts via RAN Connect behandlas som konfidentiella, och vi implementerar
          säkerhetsåtgärder enligt branschstandard för att skydda dem. Du är dock medveten om att inget onlinesystem kan
          vara 100 procent säkert.
          <br /><br />
          När det gäller personuppgifter fungerar kunden som personuppgiftsansvarig och RAN Group som
          personuppgiftsbiträde. Parternas databehandling regleras av det ovan nämnda dataskyddsavtalet.
          <br /><br />
          <strong>6. Immateriella rättigheter</strong>
          <br /><br />
          Alla rättigheter, äganderätter och intressen i RAN Connect, inklusive programvara, varumärken och innehåll,
          förblir RAN Groups egendom. Användarna beviljas en begränsad, icke-exklusiv, icke-överlåtbar licens att
          använda Tjänsten under avtalstiden med RAN Group.
          <br /><br />
          <strong>7. Tillgänglighet och support</strong>
          <br /><br />
          Vi strävar efter att tillhandahålla kontinuerlig tillgänglighet, men garanterar inte att Tjänsten är
          tillgänglig utan avbrott eller fel. Planerade underhållsarbeten eller uppdateringar kan leda till tillfällig
          otillgänglighet, och support tillhandahålls via {{ brandService.brand().supportEmail }}. <br /><br />
          <strong>8. Kontohantering och kunddata</strong>
          <br /><br />
          Kunden ansvarar för att konfigurera åtkomsträttigheter, skydda inloggningsuppgifter och alla aktiviteter under
          sina konton. Kunden måste omedelbart inaktivera åtkomsten för användare som lämnar företaget. Tillgång till
          Tjänsten kan endast beviljas auktoriserade anställda, representanter eller partners till Kunder som samarbetar
          med RAN Group.
          <br /><br />
          Mellan parterna äger Kunden alla data och allt innehåll som skickas till Tjänsten (Kunddata). Kunden beviljar
          RAN Group en icke-exklusiv licens att lagra, bearbeta och överföra Kunddata enbart i syfte att tillhandahålla
          och stödja Tjänsten. RAN Group kan också använda Kunddata i anonymiserad och aggregerad form för att utveckla,
          förbättra eller förfina sina tjänster eller för andra lagliga ändamål.
          <br /><br />
          <strong>9. Uppsägning</strong>
          <br /><br />
          Vardera parten kan säga upp åtkomsten i skriftlig form, med förbehåll för avtalsenliga skyldigheter. RAN Group
          kan omedelbart avbryta eller avsluta åtkomsten om Tjänsten missbrukas eller om dessa villkor bryts. Om Kunden
          säger upp avtalet förlorar hen åtkomsten till tjänsten.
          <br /><br />
          <strong>10. Ansvarsbegränsning</strong>
          <br /><br />
          RAN Group ansvarar inte för indirekta, tillfälliga eller följdskador som uppstår till följd av användningen av
          Tjänsten.
          <br /><br />
          <strong>11. Ändringar av villkor</strong>
          <br /><br />
          Vi kan uppdatera dessa villkor då och då. Väsentliga ändringar kommer att meddelas Användarna. Fortsatt
          användning av Tjänsten efter uppdateringar innebär att du accepterar de nya villkoren.
          <br /><br />
          <strong>Kontakt</strong>
          <br />
          {{ brandService.brand().supportEmail }}
          <br />
          {{ brandService.brand().legalEmail }}
        </p-fluid>
      } @else if (translocoService.getActiveLang() === "no") {
        <!-- NORWEGIAN CONTENT -->
        <div class="mb-5">
          @if (config.data?.organization?.tosAcceptedByUser) {
            <p class="dark:text-surface-400">
              {{ config.data?.organization?.tosAcceptedByUser?.fullName }} godtok vilkårene for bruk
              {{ config.data?.organization?.tosAcceptedAt | ranDate: "dateLong" }}.
            </p>
          } @else {
            <p class="dark:text-surface-400">
              Organisasjonsadministrator må godta tjenestevilkårene før tjenesten kan tas i bruk.
            </p>
          }
        </div>
        <p-fluid class="pr-4">
          Organisasjon: <strong>{{ config.data?.organization?.name! }}</strong>
          <br />
          Ikrafttredelsesdato: <strong>{{ effectiveDate | ranDate: "dateLong" }}</strong>
          <br />
          Sist oppdatert: <strong>{{ lastUpdatedDate | ranDate: "dateLong" }}</strong> <br /><br />
          <strong>1. Generelt</strong>
          <br /><br />
          RAN Group Oy ("RAN Group", "vi", "vår", "oss") tilbyr RAN Connect (tjenesten) til sine kunder og andre
          organisasjoner ("Kunden", "du"). Tjenesten er en sikker nettplattform som muliggjør kommunikasjon,
          dokumentdeling og prosesshåndtering mellom ansatte i RAN Group og kundene.
          <br /><br />
          Ved å velge "Jeg godtar" eller ved å få tilgang til eller bruke tjenesten, godtar du å være bundet av disse
          vilkårene. Avtalen om bruk av tjenesten består av disse tjenestevilkårene, en kundespesifikk tjenesteavtale,
          Taloushallintoliittos (Finske bransje- og interesseorganisasjonen for regnskap, økonomistyring og
          finansadministrasjon) generelle vilkår (<a
            href="https://www.rantalainen.fi/wp-content/uploads/2024/04/General-conditions-of-contract-TAL2023.pdf"
            target="_blank"
            >TAL2023</a
          >), samt databehandleravtalen som er tilgjengelig på
          <a [href]="brandService.brand().gdprUrls.no" target="_blank">{{ brandService.brand().gdprUrls.no }}</a
          >. Ved motstridende punkter gjelder følgende prioriteringsrekkefølge: (1) kundespesifikk avtale, (2)
          databehandleravtale, (3) TAL2023, (4) disse vilkårene.<br /><br />
          <strong>2. Prising og endringer i prising</strong>
          <br /><br />
          Tjenesten tilbys kundene kostnadsfritt. Enkelte valgfrie funksjoner kan imidlertid være underlagt separate
          avgifter. Slike avgifter vil alltid bli kommunisert til kunden på forhånd, og kunden kan selv velge å aktivere
          disse funksjonene i tjenesten. Vi kan også introdusere nye betalte funksjoner eller justere priser med 30
          dagers varsel, og kunden kan deaktivere slike funksjoner før endringene trer i kraft.
          <br /><br />
          <strong>3. Tjenestens omfang</strong>
          <br /><br />
          RAN Connect tilbyr sikker filoverføring og prosesshåndtering mellom RAN Group og kundene. Tjenesten er
          utelukkende ment for forretningsbruk i forbindelse med RAN Groups regnskaps-, lønns- og rådgivningstjenester.
          Nye funksjoner kan bli lagt til uten forhåndsvarsel.
          <br /><br />
          <strong>4. Brukeransvar</strong>
          <br /><br />
          Du forplikter deg til å holde innloggingsopplysninger konfidensielle og sikre, sørge for at filer eller
          meldinger du laster opp ikke bryter gjeldende lovgivning eller tredjeparts rettigheter, og bruke tjenesten kun
          til lovlige forretningsformål i samsvar med disse vilkårene.
          <br /><br />
          Forbudte handlinger inkluderer opplasting av skadelig programvare, ulovlig eller støtende innhold; forsøk på
          uautorisert tilgang til tjenesten eller dens infrastruktur; samt bruk av tjenesten for å konkurrere med RAN
          Group.
          <br /><br />
          <strong>5. Databeskyttelse og konfidensialitet</strong>
          <br /><br />
          RAN Group behandler personopplysninger i samsvar med gjeldende finsk og EU-lovgivning (GDPR). All informasjon
          og alle filer som utveksles via RAN Connect behandles som konfidensielle, og vi benytter sikre
          bransjestandarder for å beskytte dem. Du erkjenner imidlertid at ingen nettbasert løsning kan være 100 %
          sikker.
          <br /><br />
          Når det gjelder personopplysninger, er kunden behandlingsansvarlig og RAN Group er databehandler. Partenes
          behandling av personopplysninger reguleres av databehandleravtalen nevnt ovenfor.
          <br /><br />
          <strong>6. Immaterielle rettigheter</strong>
          <br /><br />
          Alle rettigheter, eierskap og interesser knyttet til RAN Connect, inkludert programvare, varemerker og
          innhold, tilhører RAN Group. Brukere gis en begrenset, ikke-eksklusiv og ikke-overførbar lisens til å bruke
          tjenesten i avtaleperioden med RAN Group.
          <br /><br />
          <strong>7. Tilgjengelighet og support</strong>
          <br /><br />
          Vi tilstreber kontinuerlig tilgjengelighet, men garanterer ikke at tjenesten vil være uten avbrudd eller feil.
          Planlagt vedlikehold eller oppdateringer kan føre til midlertidig utilgjengelighet. Support tilbys via
          {{ brandService.brand().supportEmail }}. <br /><br />
          <strong>8. Kontoadministrasjon og kundedata</strong>
          <br /><br />
          Kunden er ansvarlig for å konfigurere tilgangsrettigheter, sikre innloggingsopplysninger og all aktivitet som
          skjer under deres kontoer. Kunden må umiddelbart deaktivere tilgang for brukere som ikke lenger skal ha
          tilgang. Tilgang til tjenesten kan kun gis til autoriserte ansatte, representanter eller partnere som
          samarbeider med RAN Group.
          <br /><br />
          Mellom partene eier kunden alle data og alt innhold som sendes inn i tjenesten ("kundedata"). Kunden gir RAN
          Group en ikke-eksklusiv lisens til å lagre, behandle og overføre kundedata utelukkende for å levere og støtte
          tjenesten. RAN Group kan også bruke kundedata i anonymisert og aggregert form for å utvikle, forbedre eller
          videreutvikle sine tjenester eller til andre lovlige formål.
          <br /><br />
          <strong>9. Oppsigelse</strong>
          <br /><br />
          Begge parter kan si opp tilgangen med skriftlig varsel, i henhold til avtaleforpliktelser. RAN Group kan
          suspendere eller avslutte tilgang umiddelbart ved misbruk av tjenesten eller brudd på disse vilkårene. Dersom
          kunden sier opp avtalen, mister de tilgangen til tjenesten.
          <br /><br />
          <strong>10. Ansvarsbegrensning</strong>
          <br /><br />
          RAN Group er ikke ansvarlig for indirekte, tilfeldige eller følgeskader som oppstår ved bruk av tjenesten.
          <br /><br />
          <strong>11. Endringer i vilkårene</strong>
          <br /><br />
          Vi kan oppdatere disse vilkårene. Vesentlige endringer vil bli kommunisert til brukerne. Videre bruk av
          tjenesten etter oppdateringer innebærer aksept av de nye vilkårene.
          <br /><br />
          <strong>Kontakt</strong>
          <br />
          {{ brandService.brand().supportEmail }}
          <br />
          {{ brandService.brand().legalEmail }}
        </p-fluid>
      }
    </div>
    <!-- Footer section - fixed -->
    <div class="flex-none mt-3 pt-3 border-t border-surface-200 dark:border-surface-700">
      <div class="flex flex-row flex-wrap gap-3 justify-end">
        <p-button [label]="t('app.common.cancel')" severity="secondary" (click)="cancel()"></p-button>
        @if (config.data?.canAcceptTos && !config.data?.previewMode) {
          <p-button
            [label]="t('app.tos.dialog.acceptOnBehalfOfOrganizationButton')"
            (click)="acceptTosOnBehalfOfOrganization()"
          ></p-button>
        }
      </div>
    </div>
  </div>
</ng-container>
